import React, { useContext, useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { AuditList } from './List';
import { AuditView } from './View';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';

export const Audit = () => {
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);

  useEffect(() => {
    setHeader(formatMessage({ id: 'admin.audit.header', defaultMessage: 'User log' }));
  }, [setHeader, formatMessage]);

  return (
    <Routes>
      <Route path="/" element={<AuditList />} />
      <Route path=":id" element={<AuditView />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
